import { render, staticRenderFns } from "./SmDialogCheckbox.vue?vue&type=template&id=0af01d2a&"
import script from "./SmDialogCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SmDialogCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports